import axios from '../utils/axios';

const getPartnerBySlug = async (slug) => {
	const { data: { data } } = await axios.get(`/api/partners/${slug}`);
	return data;
};

export {
	getPartnerBySlug
};
